import React, { Component } from 'react';
import Http from '../../../Http';
import toast from 'react-hot-toast';

export default class Correo extends Component {
  state = {
    loading: true,
    saving: false,
    correo_autorizacion: false,
    correo_otra_sucursal: false,
    correo_cco: '',
    emailError: '',
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ loading: true });
    try {
      const res = await Http.get('prop/user');
      if (!res.error && res.data) {
        const d = res.data;
        this.setState({
          correo_autorizacion: Boolean(Number(d.correo_autorizacion)),
          correo_otra_sucursal: Boolean(Number(d.correo_otra_sucursal)),
          correo_cco: d.correo_cco || '',
        });
      } else {
        toast.error('No se pudo cargar la configuración de correos');
      }
    } catch (error) {
      console.error('[Correo@loadData]', error);
      toast.error('Error al consultar configuración de correos');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleToggle = (field) => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };

  handleTextChange = (e) => {
    this.setState({ correo_cco: e.target.value, emailError: '' });
  };

  validateEmail = (email) => {
    if (!email) return true;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const { correo_autorizacion, correo_otra_sucursal, correo_cco } = this.state;

    if (correo_cco && !this.validateEmail(correo_cco.trim())) {
      this.setState({ emailError: 'Por favor ingresa un correo electrónico válido' });
      toast.error('El formato de correo CCO no es válido');
      return;
    }

    this.setState({ saving: true, emailError: '' });
    try {
      const payload = {
        correo_autorizacion: correo_autorizacion ? 1 : 0,
        correo_otra_sucursal: correo_otra_sucursal ? 1 : 0,
        correo_cco: correo_cco ? correo_cco.trim() : '',
      };

      const res = await Http.post('prop/user/save', payload);
      if (!res.error) {
        toast.success('¡Configuración de correos guardada con éxito!');
      } else {
        toast.error(res.errMsg || 'Error al guardar configuración de correos');
      }
    } catch (error) {
      console.error('[Correo@handleSubmit]', error);
      toast.error('Error de conexión al guardar correos');
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const {
      loading,
      saving,
      correo_autorizacion,
      correo_otra_sucursal,
      correo_cco,
      emailError,
    } = this.state;

    if (loading) {
      return (
        <div className="w-full flex flex-col items-center justify-center p-16">
          <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-gray-500 text-sm font-medium">Cargando configuración de correos...</p>
        </div>
      );
    }

    return (
      <form onSubmit={this.handleSubmit} className="space-y-8">
        {/* Section 1: Reglas de Notificación Automática */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-5">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Notificaciones y Alertas Automáticas</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Define cuándo se enviarán avisos automáticos por correo a los responsables del sistema.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-purple-50 text-purple-700 border border-purple-200 rounded-md">
              Alertas SMTP
            </span>
          </div>

          <div className="space-y-4">
            {/* Toggle 1: Autorización fuera de horario */}
            <div
              onClick={() => this.handleToggle('correo_autorizacion')}
              className={`p-5 rounded-xl border transition-all cursor-pointer flex items-center justify-between gap-4 ${
                correo_autorizacion
                  ? 'bg-orange-50/40 border-orange-200 shadow-2xs'
                  : 'bg-gray-50/50 border-gray-200/80 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start gap-3.5">
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 ${
                    correo_autorizacion
                      ? 'bg-orange-600 text-white'
                      : 'bg-gray-200 text-gray-600'
                  }`}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">
                    Autorización por Recolección Fuera de Horario
                  </h4>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Envía un correo de notificación solicitando autorización especial cuando un usuario programe una recolección fuera del horario laboral establecido.
                  </p>
                </div>
              </div>

              {/* Custom Switch Component */}
              <div
                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden ${
                  correo_autorizacion ? 'bg-orange-600' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out ${
                    correo_autorizacion ? 'translate-x-5' : 'translate-x-0'
                  }`}
                />
              </div>
            </div>

            {/* Toggle 2: Preguía desde otra sucursal */}
            <div
              onClick={() => this.handleToggle('correo_otra_sucursal')}
              className={`p-5 rounded-xl border transition-all cursor-pointer flex items-center justify-between gap-4 ${
                correo_otra_sucursal
                  ? 'bg-orange-50/40 border-orange-200 shadow-2xs'
                  : 'bg-gray-50/50 border-gray-200/80 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start gap-3.5">
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 ${
                    correo_otra_sucursal
                      ? 'bg-orange-600 text-white'
                      : 'bg-gray-200 text-gray-600'
                  }`}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">
                    Avisos de Preguías Cruzadas entre Sucursales
                  </h4>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Notifica de forma inmediata vía correo cuando una preguía u orden de recolección sea capturada desde una sucursal distinta a la sucursal origen.
                  </p>
                </div>
              </div>

              {/* Custom Switch Component */}
              <div
                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden ${
                  correo_otra_sucursal ? 'bg-orange-600' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out ${
                    correo_otra_sucursal ? 'translate-x-5' : 'translate-x-0'
                  }`}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: Auditoría y Respaldo CCO */}
        <div className="border-b border-gray-100 pb-8">
          <div className="flex items-start justify-between gap-4 mb-5">
            <div>
              <h3 className="text-lg font-bold text-gray-900">Copia Oculta de Auditoría (CCO)</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Dirección general que recibirá una copia silenciosa de todas las notificaciones emitidas por el sistema.
              </p>
            </div>
            <span className="text-xs font-semibold px-2.5 py-1 bg-gray-100 text-gray-600 rounded-md">
              Auditoría
            </span>
          </div>

          <div className="max-w-xl">
            <label htmlFor="correo_cco" className="block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
              Dirección de correo CCO
            </label>
            <div className="relative rounded-lg shadow-2xs">
              <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                type="email"
                id="correo_cco"
                name="correo_cco"
                value={correo_cco}
                onChange={this.handleTextChange}
                placeholder="auditoria@miempresa.com"
                className={`w-full pl-10 pr-4 py-2.5 bg-gray-50/50 border rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:bg-white focus:outline-hidden focus:ring-2 transition-all ${
                  emailError
                    ? 'border-red-300 focus:ring-red-500/20 focus:border-red-500'
                    : 'border-gray-200 focus:ring-orange-500/20 focus:border-orange-500'
                }`}
              />
            </div>
            {emailError ? (
              <p className="text-xs text-red-600 mt-1.5 font-medium">{emailError}</p>
            ) : (
              <p className="text-xs text-gray-400 mt-1.5">
                Opcional. Recibirá copia de confirmaciones de recolección, avisos y cancelaciones.
              </p>
            )}
          </div>
        </div>

        {/* Action */}
        <div className="flex items-center justify-end gap-3 pt-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-semibold text-white bg-orange-600 hover:bg-orange-700 active:bg-orange-800 shadow-sm transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                <span>Guardando cambios...</span>
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Guardar Configuración de Correos</span>
              </>
            )}
          </button>
        </div>
      </form>
    );
  }
}
